import { Controller } from "@hotwired/stimulus"
import { ANIM_PRIORITY } from "@primeta/persona-core"

export default class extends Controller {
  connect() {
    const name = this.element.dataset.animationTrigger
    if (!name) return

    const loopOverride = this.element.dataset.animationLoop || null
    const source = this.element.dataset.animationSource || "tool"
    const priority = source === "hook" ? ANIM_PRIORITY.HOOK : ANIM_PRIORITY.TOOL

    console.log(`[Primeta] animation → ${name} (source: ${source}, priority: ${priority}${loopOverride ? `, loop: ${loopOverride}` : ''})`)

    const avatarEl = document.querySelector('[data-controller="avatar"]')
    const avatarCtrl = avatarEl?.avatarController
    if (avatarCtrl) {
      avatarCtrl.playAnimation(name, loopOverride, priority)
    }

    this.element.remove()
  }
}
